// extracted by mini-css-extract-plugin
module.exports = {"power-independence-N":"N_power-independence-N__VqG_0"};